export default "__VITE_ASSET__DC9r3AQl__"